import _ from "lodash";

// constants
import { LOCAL_STORAGE_ACCESS_KEYS } from "@constant";
import { numberConversion } from "@utilscommon";
import { loadFromLocalDB, setInLocalDB } from "../../../reducers/localstorage";
import { REVIEWER_LOCALSTORAGE_STRUCTURE } from "@reviewerconstant";

// action types
import {
  REVIEWER_LOGIN,
  REVIEWER_LOGOUT,
  REVIEWER_RESPONSES,
  REVIEWER_ALL_CRITERIA,
  REVIEWER_ALL_REVIEW,
} from "@revieweractions";

export const reviewerToken = (state = {}, action) => {
  let localReviewer = loadFromLocalDB(LOCAL_STORAGE_ACCESS_KEYS.reviewer);

  if (_.isEmpty(localReviewer) || _.isEqual(action.type, REVIEWER_LOGOUT)) {
    localReviewer = _.cloneDeep(REVIEWER_LOCALSTORAGE_STRUCTURE);
  }

  if (_.isEqual(action.type, REVIEWER_LOGIN)) {
    let local_payload = action.payload;
    localReviewer.sessionToken = local_payload?.session_token ?? "";
    localReviewer.sessionId = local_payload?.session_id ?? "";
    localReviewer.email = local_payload?.email ?? "";
    localReviewer.firstName = local_payload?.first_name ?? "";
    localReviewer.lastName = local_payload?.last_name ?? "";
    localReviewer.dfId = local_payload?.id
      ? numberConversion(local_payload?.id)
      : 0;
    localReviewer.userid = local_payload?.appuserid
      ? numberConversion(local_payload?.appuserid)
      : 0;
    localReviewer.eventid = local_payload?.eventid
      ? numberConversion(local_payload?.eventid)
      : 0;
  }

  setInLocalDB({
    key: LOCAL_STORAGE_ACCESS_KEYS.reviewer,
    value: localReviewer,
  });
  return localReviewer;
};

export const reviewerResponsesReducer = (state = {}, action) => {
  if (_.isEqual(action.type, REVIEWER_RESPONSES)) return action.payload;
  return state;
};

export const reviewerAllCriteriaReducer = (state = [], action) => {
  if (_.isEqual(action.type, REVIEWER_ALL_CRITERIA)) return action.payload;
  return state;
};

export const reviewerAllReviewsReducer = (state = [], action) => {
  if (_.isEqual(action.type, REVIEWER_ALL_REVIEW)) return action.payload;
  return state;
};
